import toastr from "toastr";

export class SheriffControls {

	constructor () {
		this.sheriffsIncement = 0;
		this.patrolsIncement = $('.row.patrol-row').length;
		this._init();
	}

	//=====================================================================
	// METHODS
	//=====================================================================

	/**
	 * Add sheriff to a patrol
	 * 
	 * @param $button
	 */
	addSheriffSelect ($button) {
		let templateId = $button.data('templateId'),
			targetRowId = $button.data('targetRowId'),
			$targetRow = $('#' + targetRowId),
			$template = $('#' + templateId),
			rowId = "tmpl-" + (this.sheriffsIncement++),
			templateHtml = $template.prop('outerHTML'),
			leaderId = $targetRow.data('leaderId');

		if ($targetRow.find('select.js-leader-select').val()) {
			templateHtml = templateHtml.replace(/\{\{i\}\}/g, rowId);
			templateHtml = templateHtml.replace(/\{\{lead\}\}/g, leaderId);
			let $newRow = $(templateHtml);
			$newRow.removeAttr('id');
			$newRow.find('.template-whisperer-select').each(function (i, el) {
				let $select = $(el);
				window.$whisperers.initSelect($select, $newRow);
				$select.addClass('js-whisperer-select');
				$select.removeClass('template-whisperer-select');
			});

			$newRow.show();
			$('#' + targetRowId + ' .patrol-sheriffs-cell').append($newRow);
		} else {
			toastr.error($Lang.shifts.selectLeaderFirst);
		}
	}

	/**
	 * Add new patrol
	 * 
	 * @param $button
	 */
	addPatrol ($button) {
		let templateId = $button.data('templateId'),
			tbodyId = $button.data('targetId'),
			$template = $('#' + templateId),
			rowId = (this.patrolsIncement++),
			sheriffId = "tmpl-" + (this.sheriffsIncement++),
			templateHtml = $template.find('tr').prop('outerHTML');

		templateHtml = templateHtml.replace(/\{\{row\}\}/g, rowId);
		templateHtml = templateHtml.replace(/\{\{i\}\}/g, sheriffId);
		let $newRow = $(templateHtml);
		$newRow.find('.template-whisperer-select').each(function (i, el) {
			let $select = $(el);
			window.$whisperers.initSelect($select, $newRow);
			$select.addClass('js-sheriff-select');
			$select.addClass('js-whisperer-select');
			$select.removeClass('template-whisperer-select');
		});
		//$newRow.attr('id', "sheriff-row-" + rowId);
		$newRow.show();
		$('#' + tbodyId).append($newRow);
	}

	/**
	 * Patrol leader changed
	 * 
	 * @param $select
	 */
	updateLeaderId ($select) {
		let id = $select.val(),
			$row = $select.closest('.patrol-row');
		$row.data('leaderId', id);
		$row.find('input.sheriff-patrol-leader-id').val(id);
	}

	/**
	 * 
	 * @param $select
	 */
	checkDuplicity ($select) {
		let $block = $select.closest('.shift-detail'),
			sheriffs = {};
		
		$block.find('select.js-whisperer-select').each(function (i, e) {
			let $s = $(e),
				val = $s.val();
			if (val && (val in sheriffs)) {
				sheriffs[val].parent().addClass('has-error');
				$s.parent().addClass('has-error');
				toastr.error($Lang.shifts.sheriffsMustBeUnique);
			} else {
				$s.parent().removeClass('has-error');
				sheriffs[val] = $s;
			}
		});
	}

	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document);

		$document.on('click', ".js-add-sheriff-select", function (e) {
			e.preventDefault();
			app.addSheriffSelect($(this));
		});
		$document.on('click', ".js-add-patrol-row", function (e) {
			e.preventDefault();
			app.addPatrol($(this));
		});

		$document.on('change', '.js-leader-select', function () {
			app.updateLeaderId($(this));
		});
		
		$document.on('change', '.js-leader-select, .js-sheriff-select', function () {
			app.checkDuplicity($(this));
		});

	}

	_init() {
		this.handleButtons();
	}
}

